import httpService from "app/services/httpService";
import config from "../../../src/config.json";

const apiUrl = config.apiUrl;

const addCharter = async (values) => {
  try {
    const { data } = await httpService.post(`${apiUrl}/flight`, values);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const getAirportsDetails = async (query) => {
  const { data } = await httpService.get(
    `${apiUrl}/airports?searchText=${query}`
  );
  return data;
};

const getAirlineDetails = async (query) => {
  const {
    data: { data },
  } = await httpService.get(`${apiUrl}/flight/carrier?searchText=${query}`);
  return data;
};

const getCharterFlights = async () => {
  const { data } = await httpService.get(`${apiUrl}/flight`);
  return data;
};

const getCharterFlightById = async (id) => {
  const { data } = await httpService.get(`${apiUrl}/flight/${id}`);
  return data;
};

const getcharterRequest = async (queryString) => {
  try {
    const url = `${apiUrl}/flight${queryString ? `?${queryString}` : ""}`;
    const data = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const updateCharter = async (values) => {
  try {
    const { data } = await httpService.post(`${apiUrl}/flight/update`, values);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const deleteCharter = async (id) => {
  try {
    const { data } = await httpService.post(`${apiUrl}/flight/delete/${id}`);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const deleteCharterRow = async (id) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/flight/delete/list/${id}`
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};
const actionCharterFlight = async (value) => {
  try {
    const url = `${apiUrl}/flight/disable-charted-flight`;
    const { data } = await httpService.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};

export {
  addCharter,
  getAirportsDetails,
  getAirlineDetails,
  getCharterFlights,
  getCharterFlightById,
  getcharterRequest,
  updateCharter,
  deleteCharter,
  deleteCharterRow,
  actionCharterFlight,
};
